export class UsersModel {
    public dob: string;
    public emailaddress: string;
    public firstname: string;
    public fullname: string;
    public isactive: boolean;
    public islogin: boolean;
    public lastname: string;
    public middleinitial: string;
    public password: string;
    public payorid: number;
    public phone: string;
    public roleid: number;
    public userprofileid: number;
    public usertypeid: number;
    public defaultproviderid: number;
    public UserProviders: any[];
    public role: any;
}



// WEBPACK FOOTER //
// ./src/app/pages/users/users.model.ts